import React, { useEffect, useState, Component } from 'react';
import { motion } from 'framer-motion';
export function ContactSection() {
  const [message, setMessage] = useState('');
  // Check for pre-filled message from URL
  useEffect(() => {
    const hash = window.location.hash;
    if (hash.includes('kontakt?')) {
      const params = new URLSearchParams(hash.split('?')[1]);
      const zprava = params.get('zprava');
      if (zprava) {
        setMessage(decodeURIComponent(zprava));
        // Scroll to contact section
        const contactSection = document.getElementById('kontakt');
        if (contactSection) {
          contactSection.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    }
  }, []);
  return <section id="kontakt" className="py-24 bg-white" data-id="element-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-34">
          <h2 className="font-heading text-4xl md:text-5xl text-primary mb-4" data-id="element-35">
            Kontaktujte nás
          </h2>
          <p className="text-base-gray max-w-2xl mx-auto" data-id="element-36">
            Máte zájem projekt Svatý Václav? Dejte nám vědět.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-37">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-38">
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-39">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-40">
                <div data-id="element-41">
                  <label htmlFor="name" className="block text-sm font-medium text-base-dark mb-2" data-id="element-42">
                    Jméno a příjmení
                  </label>
                  <input type="text" id="name" className="w-full bg-base-cream border border-transparent focus:border-primary focus:ring-0 rounded-sm px-4 py-3 outline-none transition-colors" placeholder="Jan Novák" data-id="element-43" />
                </div>
                <div data-id="element-44">
                  <label htmlFor="phone" className="block text-sm font-medium text-base-dark mb-2" data-id="element-45">
                    Telefon
                  </label>
                  <input type="tel" id="phone" className="w-full bg-base-cream border border-transparent focus:border-primary focus:ring-0 rounded-sm px-4 py-3 outline-none transition-colors" placeholder="+420 123 456 789" data-id="element-46" />
                </div>
              </div>
              <div data-id="element-47">
                <label htmlFor="email" className="block text-sm font-medium text-base-dark mb-2" data-id="element-48">
                  E-mail
                </label>
                <input type="email" id="email" className="w-full bg-base-cream border border-transparent focus:border-primary focus:ring-0 rounded-sm px-4 py-3 outline-none transition-colors" placeholder="jan.novak@email.cz" data-id="element-49" />
              </div>
              <div data-id="element-50">
                <label htmlFor="message" className="block text-sm font-medium text-base-dark mb-2" data-id="element-51">
                  Zpráva
                </label>
                <textarea id="message" rows={4} value={message} onChange={e => setMessage(e.target.value)} className="w-full bg-base-cream border border-transparent focus:border-primary focus:ring-0 rounded-sm px-4 py-3 outline-none transition-colors resize-none" placeholder="Dobrý den, měl bych zájem o informace k bytu 3+kk..." data-id="element-52"></textarea>
              </div>
              <button type="submit" className="w-full bg-primary hover:bg-primary-light text-white px-8 py-4 rounded-sm transition-colors duration-300 font-medium tracking-wide mb-[0px] mt-[50px]" data-id="element-53">
                Odeslat zprávu
              </button>
            </form>
          </motion.div>

          {/* Developer Info */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative bg-primary-dark text-white p-10 rounded-2xl flex flex-col overflow-hidden shadow-xl h-full" data-id="element-54">
            {/* Background Image */}
            <img src="https://cdn.magicpatterns.com/uploads/p1jZefST6qKiRGW7GWUgDS/2.png" alt="Komerční prostory" className="absolute inset-0 w-full h-full object-cover opacity-30 mix-blend-luminosity" data-id="element-55" />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-dark via-primary-dark/90 to-primary-dark/40" data-id="element-56"></div>

            <div className="relative z-10" data-id="element-57">
              <span className="text-accent text-sm font-medium tracking-widest uppercase mb-4 block" data-id="element-58">
                Developer projektu
              </span>
              <h3 className="font-heading text-3xl mb-8 text-[#FFFFFF]" data-id="element-59">
                BRAMAL PROJECT s.r.o.
              </h3>

              <div className="space-y-6 text-white/80" data-id="element-60">
                <div data-id="element-61">
                  <p className="text-sm text-white/50 mb-1" data-id="element-62">Adresa projektu</p>
                  <p className="text-lg" data-id="element-63">
                    Dolní Jirčany
                    <br data-id="element-64" />
                    Praha-západ
                  </p>
                </div>
                <div data-id="element-65">
                  <p className="text-sm text-white/50 mb-1" data-id="element-66">Telefon</p>
                  <p className="text-lg" data-id="element-67">+420 602 304 915</p>
                </div>
                <div data-id="element-68">
                  <p className="text-sm text-white/50 mb-1" data-id="element-69">E-mail</p>
                  <p className="text-lg" data-id="element-70">info@svatyvaclav.living</p>
                </div>
              </div>
            </div>

            <div className="relative z-10 mt-auto pt-8 border-t border-white/10" data-id="element-71">
              <p className="text-sm text-white/60 italic" data-id="element-72">
                Dům u Sv. Václava je jediný projekt developera BRAMAL PROJECT
                s.r.o.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}